import matchList from '@gin-betting/match-list';
import { List } from 'immutable';
import { createStructuredSelector } from 'reselect';

import { useMemoSelector } from 'hooks';

const {
    selectors: { selectTopMarketIdsByMatchId },
} = matchList;

interface Input {
    sportEventId: string;
}

interface Output {
    topMarketIds: List<string>;
}

export default function useTopMarkets({ sportEventId }: Input): Output {
    const { topMarketIds = List() } = useMemoSelector(makeSelectProps(), {
        matchId: sportEventId,
    });

    return {
        topMarketIds,
    };
}

const makeSelectProps = () => {
    return createStructuredSelector({
        topMarketIds: selectTopMarketIdsByMatchId,
    });
};
